import React, { useEffect, useState } from "react";
import { Box, Flex, Grid, GridItem, Text } from "@chakra-ui/react";

import BasicInformation from "./components/BasicInformation";
import BusinessDetails from "./components/BusinessDetails";
import ServiceRequirement from "./components/ServiceRequirment";
import GoalTimeline from "./components/GoalTimeline";
import DecisionInternalSales from "./components/DecisionInternalSales";
import { IBasicInformation } from "./modal";



interface Props {
  leadId: number;
  leadData?: any;
  onClose?: () => void;
}
const LeadRequirement = ({ leadId, leadData, onClose }: Props) => {
  const [activeStep, setActiveStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState<number[]>([]);

  const [formData, setFormData] = useState({
    basicInfo: {} as IBasicInformation,
    businessDetails: {},
    serviceRequirements: {},
    goalsBudget: {},
    decisionNotes: {},
  });


  useEffect(() => {
    if (leadData) {
      setFormData((prev) => ({
        ...prev,
        basicInfo: {
          company_name: leadData.companyName || "",
          companyPhone: leadData.companyPhone || "",
          websiteUrl: leadData.websiteUrl || "",
          industrytypeId: leadData.industrytypeId || null,
          sourceId: leadData.sourceId || null,
          contactPersonName: leadData.pocName || "",
          companySize: leadData.companySize || "",
          designationId: leadData.designationId || null,
          companyEmail: leadData.companyEmail || "",
          countryId: leadData.countryId || null,

          socialLinks:
            leadData.socialLinks?.length > 0
              ? leadData.socialLinks.map((item: any) => ({
                socialLink: item.socialLink,
              }))
              : [{ socialLink: "" }],
        },
      }));
    }
  }, [leadData]);
  const nextStep = () => {
    setCompletedSteps((prev) => {
      if (prev.includes(activeStep)) return prev;
      return [...prev, activeStep];
    });

    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const steps = [
    {
      title: "Basic Information",
      render: () => (
        <BasicInformation
          leadId={leadId}
          basicInfo={formData.basicInfo}
          setBasicInfo={(data) =>
            setFormData((prev) => ({
              ...prev,
              basicInfo: data,
            }))
          }
          nextStep={nextStep}
          prevStep={prevStep}
        />
      ),
    },
    {
      title: "Business Details",
      render: () => (
        <BusinessDetails
          leadId={leadId}
          businessDetails={formData.businessDetails}
          setBusinessDetails={(data) =>
            setFormData((prev) => ({
              ...prev,
              businessDetails: data,
            }))
          }
          nextStep={nextStep}
          prevStep={prevStep}
          onSuccess={onClose}
        />
      ),
    },
    // {
    //   title: "Service Requirements",
    //   render: () => (
    //     <ServiceRequirement

    //       nextStep={nextStep}
    //       prevStep={prevStep}
    //       serviceRequirements={formData.serviceRequirements}
    //       setServiceRequirements={(data) =>
    //         setFormData((prev) => ({
    //           ...prev,
    //           serviceRequirements: data,
    //         }))
    //       }
    //     />
    //   ),
    // },
    // {
    //   title: "Goals, Budget & Timeline",
    //   render: () => (
    //     <GoalTimeline
    //       leadId={leadId}
    //       nextStep={nextStep}
    //       prevStep={prevStep}
    //       goalsBudget={formData.goalsBudget}
    //       setGoalsBudget={(data) =>
    //         setFormData((prev) => ({
    //           ...prev,
    //           goalsBudget: data,
    //         }))
    //       }
    //     />
    //   ),
    // },
    // {
    //   title: "Decision & Internal Sales Notes",
    //   render: () => (
    //     <DecisionInternalSales
    //       leadId={leadId}
    //       prevStep={prevStep}
    //       decisionNotes={formData.decisionNotes}
    //       setDecisionNotes={(data) =>
    //         setFormData((prev) => ({
    //           ...prev,
    //           decisionNotes: data,
    //         }))
    //       }
    //        onSuccess={onClose}
    //     />
    //   ),
    // },
  ];

  return (
    <Box bg="#F4F5FB" p="16px" borderRadius="12px">
      <Grid
        templateColumns={{ base: "1fr", md: "180px 1fr" }}
        gap="16px"
        minH="500px"
      >
        {/* Stepper */}
        <GridItem>
          <Box
            bg="#FFFFFF"
            borderRadius="12px"
            p="16px"
            boxShadow="0px 2px 8px rgba(0,0,0,0.04)"
            h="100%"
          >
            <Flex direction="column" align="center">
              {steps.map((step, index) => {
                const isCompleted = completedSteps.includes(index);
                const isActive = activeStep === index;

                return (
                  <Flex key={index} direction="column" align="center">
                    <Text fontSize="11px" mb="6px" textAlign="center">
                      {step.title}
                    </Text>

                    <Box
                      w="24px"
                      h="24px"
                      borderRadius="50%"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      bg={isCompleted ? "#22C55E" : "#FFFFFF"}
                      border="1px solid"
                      borderColor={isCompleted ? "#22C55E" : "#D1D5DB"}
                    >
                      {isCompleted ? (
                        <Text color="white">✓</Text>
                      ) : isActive ? (
                        <Box
                          w="10px"
                          h="10px"
                          borderRadius="50%"
                          bg="#22C55E"
                        />
                      ) : (
                        <Text fontSize="11px">{index + 1}</Text>
                      )}
                    </Box>

                    {index !== steps.length - 1 && (
                      <Box
                        w="3px"
                        h="24px"
                        bg="#E5E7EB"
                        my="4px"
                      />
                    )}
                  </Flex>
                );
              })}
            </Flex>
          </Box>
        </GridItem>

        {/* Form */}
        <GridItem>
          <Box
            bg="#FFFFFF"
            borderRadius="12px"
            p="16px"
            minH="500px"
            boxShadow="0px 2px 8px rgba(0,0,0,0.04)"
            overflow="auto"
          >
            {steps[activeStep].render()}
          </Box>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default LeadRequirement;